var ___EXPOSE_LOADER_IMPORT___ = require("-!./media-groups.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
___EXPOSE_LOADER_GLOBAL_THIS___["videojs"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
